import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useNavigate, useParams, useSearchParams, Link } from 'react-router-dom';
import validator from 'validator';
import {
  ajaxGetPurchaseOrders, ajaxSavePurchaseOrder,
  ajaxSaveShippingCostPurchaseOrder, ajaxSaveAwbPurchaseOrder,
  ajaxApprovePurchaseOrder, ajaxRejectPurchaseOrder,
  ajaxReceivePurchaseOrder, ajaxRequestApprovalPurchaseOrder,
  ajaxGetApprovalPurchaseOrderUsers, ajaxPayPurchaseOrder,
  ajaxUploadSupplierQuote, ajaxCancelPurchaseOrder
} from '../../services/purchaseOrderService';
import { ajaxGetSuppliersAutocomplete } from '../../services/supplierService';
import LoadingSpinner from '../../components/LoadingSpinner';
import LoadingButton from '../../components/LoadingButton';
import Page from '../../components/Page';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import ConfirmationButton from '../../components/ConfirmationButton';
import { noty, downloadFile } from '../../helpers';
import moment from 'moment';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import Divider from '@mui/material/Divider';
import StyledCard from '../../components/StyledCard';
import StyledCardFormContent from '../../components/StyledCardFormContent';
import UtcDatePicker from '../../components/UtcDatePicker';
import PurchaseOrderParts from '../../components/PurchaseOrderParts';
import { toDate, isFloat, formatPriceToFloat } from '../../helpers';
import inMemoryUser from '../../services/inMemoryUser';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { getAllCurrencyList } from '../../helpers';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import FormControlLabel from '@mui/material/FormControlLabel';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import FileUploader from '../../components/FileUploader';
import EditIcon from '@mui/icons-material/Edit';
import { ajaxGetPoDepartments } from '../../services/poDepartmentService';
import { ajaxGetPoTerms } from '../../services/poTermService';
import { ajaxGetPoPriceQuotes } from '../../services/poPriceQuoteService';
import PoDepartmentDialog from './PoDepartmentDialog';
import PoTermDialog from './PoTermDialog';
import PoPriceQuoteDialog from './PoPriceQuoteDialog';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

export default function PurchaseOrder(props) {
  const defaultData = {
    id: null,
    supplier: null,
    supplier_name: '',
    supplier_contact_person: '',
    supplier_2303: '',
    supplier_address: '',
    supplier_email: '',
    supplier_phone: '',
    requisitioner: '',
    po_number: '',
    po_date: moment().hour(0).minute(0).second(0).millisecond(0).unix() + (moment().utcOffset() * 60),
    due_date: moment().hour(0).minute(0).second(0).millisecond(0).unix() + (moment().utcOffset() * 60),
    purpose: '',
    department: '',
    terms: '',
    ship_to: 'iSensors Inc.\nJose Abad Santos Avenue, Bldg18-A Berthapil I Compound,\nClark Freeport Zone, Clarkfield,\nPampanga, Philippines 2023',
    price_quote: '',
    currency: 'USD',
    currency_rate: 1.0,
    status: 'draft',
    parts: [],
    local_po: 0,
    paid: 0
  };
  const { PurchaseOrderId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [duplicateErrors, setDuplicateErrors] = useState({});
  const [defaultPurchaseOrder, setDefaultPurchaseOrder] = useState(defaultData);
  const [purchaseOrder, setPurchaseOrder] = useState(defaultData);
  const [suppliers, setSuppliers] = useState([]);
  const [backUrl, setBackUrl] = useState('/purchaseorders');
  const [errors, setErrors] = useState({});
  const [submitOnce, setSubmitOnce] = useState(false);
  const [supplierChanged, setSupplierChanged] = useState(false);
  const [approvalUsers, setApprovalUsers] = useState([]);
  const [selectedApprovalUsers, setSelectedApprovalUsers] = useState([]);
  const [showApprovalDialog, setShowApprovalDialog] = useState(false);
  const [searchApprovalUser, setSearchApprovalUser] = useState('');
  const [newFileSelected, setNewFileSelected] = useState(false);
  const [fileUploaderKey, setFileUploaderKey] = useState(0);
  const [departments, setDepartments] = useState([]);
  const [terms, setTerms] = useState([]);
  const [priceQuotes, setPriceQuotes] = useState([]);
  const [showDepartmentDialog, setShowDepartmentDialog] = useState(false);
  const [showTermDialog, setShowTermDialog] = useState(false);
  const [showPriceQuoteDialog, setShowPriceQuoteDialog] = useState(false);
  const [newSupplierQuoteSelected, setNewSupplierQuoteSelected] = useState(false);
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [cancelReason, setCancelReason] = useState('');
  const [cancelError, setCancelError] = useState('');

  const paramPurchaseOrderId = (PurchaseOrderId ? PurchaseOrderId : -1);
  const isNotAdminOrPurchase = !inMemoryUser.isAdmin() && !inMemoryUser.isPurchase();
  const isCancelled = purchaseOrder.status === 'cancelled';

  useEffect(() => {
    if(searchParams.get("page") === 'dashboard') {
      setBackUrl('/dashboard')  
    } else {
      setBackUrl('/purchaseorders') 
    }
  }, [searchParams]);

  useEffect(() => {
    const loadData = () => {
      ajaxGetSuppliersAutocomplete()
        .then((supplierRes) => {
          setSuppliers(supplierRes.data);
          if (PurchaseOrderId) {
            return ajaxGetPurchaseOrders({PurchaseOrderId: PurchaseOrderId});
          }
        })
        .then((poRes) => {
          if (poRes) {
            setPurchaseOrder(poRes.data);
            setDefaultPurchaseOrder(poRes.data);
          }
        })
        .then(() => {
          return ajaxGetApprovalPurchaseOrderUsers();
        })
        .then((usersRes) => {
          if (usersRes && usersRes.data) {
            setApprovalUsers(usersRes.data);
          }
        })
        .catch((error) => {
          console.error('Error loading data:', error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    loadData();
  }, [PurchaseOrderId]);

  const supplierId = purchaseOrder ? purchaseOrder.supplier : null;
  useEffect(() => {
    const supplier = (suppliers || []).find(s => s.id === supplierId)
    if(supplierChanged && supplier) {
      setPurchaseOrder(po => ({
        ...po,
        supplier_name: supplier.name || '',
        supplier_contact_person: supplier.contact_person || '',
        supplier_2303: supplier.supplier2303 || '',
        supplier_address: supplier.address || '',
        supplier_email: supplier.email || '',
        supplier_phone: supplier.phone || '',
      }));
    }
  }, [suppliers, supplierId, supplierChanged]);

  useEffect(() => {
    loadDepartments();
    loadTerms();
    loadPriceQuotes();
  }, []);

  const loadDepartments = () => {
    ajaxGetPoDepartments()
      .then((res) => {
        setDepartments(res.data || []);
      })
      .catch((error) => {
        console.error('Error loading departments:', error);
        noty('Failed to load departments', 'error');
      });
  };

  const loadTerms = () => {
    ajaxGetPoTerms()
      .then((res) => {
        setTerms(res.data || []);
      })
      .catch((error) => {
        console.error('Error loading terms:', error);
        noty('Failed to load terms', 'error');
      });
  };

  const loadPriceQuotes = () => {
    ajaxGetPoPriceQuotes()
      .then((res) => {
        setPriceQuotes(res.data || []);
      })
      .catch((error) => {
        console.error('Error loading price quotes:', error);
        noty('Failed to load price quotes', 'error');
      });
  };

  const handleDepartmentSave = () => {
    loadDepartments();
  };

  const handleTermSave = () => {
    loadTerms();
  };

  const handlePriceQuoteSave = () => {
    loadPriceQuotes();
  };

  const allFields = useMemo(
    () => [
      ...(
        inMemoryUser.isAdmin() || inMemoryUser.isPurchase() ?
        [{
          key: 'supplier',
          type: 'autocomplete',
          label: 'Supplier',
          dataset: suppliers.map(s => ({ value: s.id, label: s.name })),
          gridProps: { xs: 12, md: 12 },
          disabled: isNotAdminOrPurchase || isCancelled
        }] : []
      ),
      {
        key: 'supplier_name',
        type: 'text',
        label: 'Supplier Name',
        required: true,
        disabled: isNotAdminOrPurchase || isCancelled,
        gridProps: { xs: 12, md: 12 }
      },
      {
        key: 'supplier_contact_person',
        type: 'text',
        label: 'Contact Person',
        required: true,
        disabled: isNotAdminOrPurchase || isCancelled,
        gridProps: { xs: 12, md: 6 }
      },
      {
        key: 'supplier_2303',
        type: 'text',
        label: 'Supplier 2303/TIN#',
        disabled: isNotAdminOrPurchase || isCancelled,
        gridProps: { xs: 12, md: 6 }
      },
      {
        key: 'supplier_email',
        type: 'text',
        label: 'Email',
        disabled: isNotAdminOrPurchase || isCancelled,
        gridProps: { xs: 12, md: 6 }
      },
      {
        key: 'supplier_phone',
        type: 'text',
        label: 'Phone Number',
        disabled: isNotAdminOrPurchase || isCancelled,
        gridProps: { xs: 12, md: 6 }
      },
      {
        key: 'supplier_address',
        type: 'text',
        label: 'Address',
        required: true,
        multiline: true,
        disabled: isNotAdminOrPurchase || isCancelled,
        gridProps: { xs: 12, md: 6 }
      },
      {
        key: 'ship_to',
        type: 'text',
        label: 'Ship To',
        multiline: true,
        disabled: isNotAdminOrPurchase || isCancelled,
        gridProps: { xs: 12, md: 6 }
      },
      {
        key: 'requisitioner',
        type: 'text',
        label: 'Requisitioner',
        required: true,
        disabled: isNotAdminOrPurchase || isCancelled,
        gridProps: { xs: 12, md: 6 }
      },
      {
        key: 'purpose',
        type: 'text',
        label: 'Purpose',
        required: true,
        disabled: isNotAdminOrPurchase || isCancelled,
        gridProps: { xs: 12, md: 6 }
      },
      {
        divider: true,
        gridProps: { xs: 12 }
      },
      {
        key: 'currency',
        type: 'autocomplete',
        label: 'Currency',
        dataset: getAllCurrencyList().map(c => ({ value: c, label: c })),
        required: true,
        disabled: isNotAdminOrPurchase || isCancelled,
        gridProps: { xs: 12, md: 6 }
      },
      {
        key: 'currency_rate',
        type: 'text',
        label: purchaseOrder.currency === 'USD' ? 'Currency Rate to USD' : `Currency Rate to USD (1 ${purchaseOrder.currency} = ${purchaseOrder.currency_rate} USD)`,
        required: true,
        disabled: isNotAdminOrPurchase || isCancelled,
        gridProps: { xs: 12, md: 6 }
      },
      {
        key: 'parts',
        type: 'component',
        component: PurchaseOrderParts,
        componentProps: {
          parts: purchaseOrder.parts.map(part => ({
            ...part,
            price_UI: part.price_UI !== undefined ? part.price_UI : formatPriceToFloat(part.price / (purchaseOrder.currency_rate || 1), 2, 6)
          })),
          currency: purchaseOrder.currency,
          currencyRate: purchaseOrder.currency_rate,
          updateParts: (newParts) => setPurchaseOrder(prev => ({ ...prev, parts: newParts })),
          disabled: isNotAdminOrPurchase || isCancelled,
        },
        gridProps: { xs: 12 }
      },
      {
        divider: true,
        gridProps: { xs: 12 }
      },
      {
        key: 'local_po',
        type: 'checkbox',
        label: 'Local PO',
        disabled: isNotAdminOrPurchase || isCancelled,
        gridProps: { xs: 12, md: 12 },
        sx: !isNotAdminOrPurchase && !isCancelled ? {
          '& .MuiFormControlLabel-label': {
            color: 'error.main'
          }
        } : undefined
      },
      {
        key: 'po_number',
        type: 'text',
        label: 'PO Number',
        disabled: true,
        gridProps: { xs: 12, md: 6 }
      },
      {
        key: 'po_date',
        type: 'date',
        label: 'PO Date',
        required: true,
        disabled: isNotAdminOrPurchase || isCancelled,
        gridProps: { xs: 12, md: 6 },
        sx: !isNotAdminOrPurchase && !isCancelled ? {
          '& .MuiInputLabel-root': {
            color: 'error.main'
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'error.main'
            },
            '&:hover fieldset': {
              borderColor: 'error.main'
            },
            '&.Mui-focused fieldset': {
              borderColor: 'error.main'
            }
          }
        } : undefined
      },
      {
        key: 'department',
        type: 'autocomplete_with_edit',
        label: 'Department',
        required: true,
        disabled: isNotAdminOrPurchase || isCancelled,
        dataset: [
          ...departments.map(d => ({ value: d.name, label: d.name })),
          ...(purchaseOrder.department && !departments.some(d => d.name === purchaseOrder.department)
            ? [{ value: purchaseOrder.department, label: purchaseOrder.department }]
            : [])
        ],
        hasEdit: true,
        onEdit: () => setShowDepartmentDialog(true),
        gridProps: { xs: 12, md: 6 },
        sx: !isNotAdminOrPurchase && !isCancelled ? {
          '& .MuiInputLabel-root': {
            color: 'error.main'
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'error.main'
            },
            '&:hover fieldset': {
              borderColor: 'error.main'
            },
            '&.Mui-focused fieldset': {
              borderColor: 'error.main'
            }
          }
        } : undefined
      },
      {
        key: 'due_date',
        type: 'date',
        label: 'Due Date',
        required: true,
        disabled: isNotAdminOrPurchase || isCancelled,
        gridProps: { xs: 12, md: 6 },
        sx: !isNotAdminOrPurchase && !isCancelled ? {
          '& .MuiInputLabel-root': {
            color: 'error.main'
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'error.main'
            },
            '&:hover fieldset': {
              borderColor: 'error.main'
            },
            '&.Mui-focused fieldset': {
              borderColor: 'error.main'
            }
          }
        } : undefined
      },
      {
        key: 'terms',
        type: 'autocomplete_with_edit',
        label: 'Terms',
        required: true,
        disabled: isNotAdminOrPurchase || isCancelled,
        dataset: [
          ...terms.map(t => ({ value: t.name, label: t.name })),
          ...(purchaseOrder.terms && !terms.some(t => t.name === purchaseOrder.terms)
            ? [{ value: purchaseOrder.terms, label: purchaseOrder.terms }]
            : [])
        ],
        hasEdit: true,
        onEdit: () => setShowTermDialog(true),
        gridProps: { xs: 12, md: 6 },
        sx: !isNotAdminOrPurchase && !isCancelled ? {
          '& .MuiInputLabel-root': {
            color: 'error.main'
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'error.main'
            },
            '&:hover fieldset': {
              borderColor: 'error.main'
            },
            '&.Mui-focused fieldset': {
              borderColor: 'error.main'
            }
          }
        } : undefined
      },
      {
        key: 'price_quote',
        type: 'autocomplete_with_edit',
        label: 'Price Quote',
        required: true,
        disabled: isNotAdminOrPurchase || isCancelled || purchaseOrder.local_po !== 1,
        dataset: [
          ...priceQuotes.map(pq => ({ value: pq.name, label: pq.name })),
          ...(purchaseOrder.price_quote && !priceQuotes.some(pq => pq.name === purchaseOrder.price_quote)
            ? [{ value: purchaseOrder.price_quote, label: purchaseOrder.price_quote }]
            : [])
        ],
        hasEdit: true,
        onEdit: () => setShowPriceQuoteDialog(true),
        gridProps: { xs: 12, md: 6 },
        sx: (!isNotAdminOrPurchase && !isCancelled && purchaseOrder.local_po === 1) ? {
          '& .MuiInputLabel-root': {
            color: 'error.main'
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'error.main'
            },
            '&:hover fieldset': {
              borderColor: 'error.main'
            },
            '&.Mui-focused fieldset': {
              borderColor: 'error.main'
            }
          }
        } : undefined
      },
      {
        divider: true,
        gridProps: { xs: 12 }
      },
      {
        key: 'prepared_by_name',
        type: 'text',
        label: 'Prepared By Name',
        disabled: true,
        gridProps: { xs: 12, md: 6 }
      },
      {
        key: 'prepared_by_position',
        type: 'text',
        label: 'Prepared By Position',
        disabled: true,
        gridProps: { xs: 12, md: 6 }
      },
      {
        key: 'approved_by_name',
        type: 'text',
        label: 'Approved By Name',
        disabled: true,
        gridProps: { xs: 12, md: 6 }
      },
      {
        key: 'approved_by_position',
        type: 'text',
        label: 'Approved By Position',
        disabled: true,
        gridProps: { xs: 12, md: 6 }
      },
      {
        divider: true,
        gridProps: { xs: 12 }
      },
      {
        key: 'status',
        type: 'list',
        label: 'Status',
        dataset: [
          { value: 'draft', label: 'Draft' },
          { value: 'waitingapproval', label: 'Waiting Approval' },
          { value: 'approved', label: 'Approved' },
          { value: 'rejected', label: 'Rejected' },
          { value: 'received', label: 'Received' },
          { value: 'cancelled', label: 'Cancelled' },
        ],
        disabled: true,
        gridProps: { xs: 12, md: 12 }
      },
      {
        divider: true,
        gridProps: { xs: 12 }
      },
      {
        key: 'shipping_cost',
        type: 'text',
        label: 'Shipping Cost',
        gridProps: { xs: 12, md: 6 },
        disabled: isCancelled || (!inMemoryUser.isAdmin() && !inMemoryUser.isPurchase() && !inMemoryUser.isShipping()) || (inMemoryUser.isShipping() && defaultPurchaseOrder.status !== 'approved' && defaultPurchaseOrder.status !== 'received'),
        convertToUI: (v) => {
          if ( purchaseOrder.shipping_cost_UI !== null && purchaseOrder.shipping_cost_UI !== undefined ){
            return purchaseOrder.shipping_cost_UI;
          }
          if (v === '' || v === null){
            return '';
          }
          return v / (purchaseOrder.currency_rate || 1)
        },
        convertToDB: (v) => isNaN(parseFloat(v)) ? null : parseFloat(v) * (purchaseOrder.currency_rate || 1),
      },
      {
        key: 'awb_number',
        type: 'text',
        label: 'AWB Number',
        disabled: isCancelled || (!inMemoryUser.isAdmin() && !inMemoryUser.isPurchase() && !inMemoryUser.isQa()) || (inMemoryUser.isQa() && defaultPurchaseOrder.status !== 'approved' && defaultPurchaseOrder.status !== 'received'),
        gridProps: { xs: 12, md: 6 }
      },
      {
        divider: true,
        gridProps: { xs: 12 }
      },
    ],
    [suppliers, purchaseOrder.parts, purchaseOrder.currency, purchaseOrder.currency_rate, purchaseOrder.shipping_cost_UI, defaultPurchaseOrder.status, isNotAdminOrPurchase, purchaseOrder.local_po, departments, terms, priceQuotes, purchaseOrder.department, purchaseOrder.terms, purchaseOrder.price_quote, isCancelled]
  );

  const requiredFields = useMemo(() => [
    'supplier',
    'supplier_name',
    'supplier_contact_person',
    'supplier_address',
    'supplier_email',
    'requisitioner',
    'po_date',
    'due_date',
    'purpose',
    'department',
    'currency',
    'currency_rate',
  ], []);

  const emailFields = useMemo(() => ['supplier_email'], []);

  const floatFields = useMemo(() => ['currency_rate', 'shipping_cost'], []);

  const validateFields = useCallback(() => {
    const fields = { ...purchaseOrder };
    let newErrors = {};
    let result = true;

    // Add currency validation
    if (fields.currency === 'USD' && fields.currency_rate !== 1 && fields.currency_rate !== '1') {
      newErrors['currency'] = 'Currency must be changed to match the currency rate';
      result = false;
    }

    for (let index in allFields) {
      let key = allFields[index].key;
      let fieldValue = fields[key] !== undefined && fields[key] !== null ? fields[key] + '' : '';
      
      if (requiredFields.includes(key) && validator.isEmpty(fieldValue, { ignore_whitespace: true })) {
        newErrors[key] = 'required field';
        result = false;
      } else if (fieldValue && emailFields.includes(key) && !validator.isEmail(fieldValue)) {
        newErrors[key] = 'Please enter a valid email address';
        result = false;
      } else if (fieldValue && floatFields.includes(key) && !isFloat(fieldValue)) {
        newErrors[key] = 'Please enter a valid number';
        result = false;
      }
      else if (key === 'parts' ) {
        for (let part of fields.parts) {
          if ( part.errors ) {
            for (let error in part.errors) {
              if (part.errors[error]) {
                newErrors[error] = part.errors[error];
                result = false;
              }
            }
          }
        }
      }
    }

    setErrors(newErrors);
    return result;
  }, [purchaseOrder, allFields, requiredFields, emailFields, floatFields]);

  useEffect(() => {
    if (!props.add) {
      validateFields();
    } else if (props.add && submitOnce) {
      validateFields();
    }
  }, [validateFields, props.add, submitOnce]);

  const handleApprove = (id) => () => {
    setIsSaving(true);
    ajaxApprovePurchaseOrder({PurchaseOrderId: id})
      .then((res) => {
        if ( !res.error ) {
          setPurchaseOrder({...res.data});
          setDefaultPurchaseOrder({...res.data});
          noty('Purchase order approved', 'success');
        }
      })
      .catch((error) => {
        console.error('Error approving purchase order:', error);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const handleRequestApproval = (id) => () => {
    setShowApprovalDialog(true);
  };

  const handleConfirmApprovalRequest = () => {
    if (selectedApprovalUsers.length === 0) {
      noty('Please select at least one user for approval', 'error');
      return;
    }

    setIsSaving(true);
    ajaxRequestApprovalPurchaseOrder({
      PurchaseOrderId: purchaseOrder.id,
      emailTo: selectedApprovalUsers
    })
      .then((res) => {
        if (!res.error) {
          setPurchaseOrder({...res.data});
          setDefaultPurchaseOrder({...res.data});
          setShowApprovalDialog(false);
          setSelectedApprovalUsers([]);
          noty('Purchase order sent for approval', 'success');
        }
      })
      .catch((error) => {
        console.error('Error requesting approval for purchase order:', error);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const handleReject = (id) => () => {
    setIsSaving(true);
    ajaxRejectPurchaseOrder({PurchaseOrderId: id})
      .then((res) => {
        if ( !res.error ) {
          setPurchaseOrder({...res.data});
          setDefaultPurchaseOrder({...res.data});
          noty('Purchase order rejected', 'success');
        }
      })
      .catch((error) => {
        console.error('Error rejecting purchase order:', error);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const handleReceive = (id) => () => {
    if (!validateFields()) return false;

    setIsSaving(true);
    ajaxReceivePurchaseOrder({PurchaseOrderId: id})
      .then((res) => {
        if ( !res.error ) {
          setPurchaseOrder({...res.data});
          setDefaultPurchaseOrder({...res.data});
          noty('Purchase order marked as received', 'success');
        }
      })
      .catch((error) => {
        console.error('Error marking purchase order as received:', error);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const handleSaveShippingCost = (id) => () => {
    if (!validateFields()) return false;
    // check if the purchase order shipping_cost and awb_number are filled
    if (purchaseOrder.shipping_cost === '' || purchaseOrder.shipping_cost === null) {
      let newErrors = {};
      if (purchaseOrder.shipping_cost === '' || purchaseOrder.awb_number === null) {
        newErrors['shipping_cost'] = 'required field';
      }
      setErrors(newErrors);
      return;
    }

    setIsSaving(true);
    ajaxSaveShippingCostPurchaseOrder({id: id, shipping_cost: purchaseOrder.shipping_cost})
      .then((res) => {
        if (!res.error) {
          noty('Save successfully', 'success');
          setPurchaseOrder({...res.data});
          setDefaultPurchaseOrder({...res.data});
        }
      })
      .catch((error) => {
        console.error('Error saving shipping cost:', error);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const handleSaveAWBNumber = (id) => () => {
    if (!validateFields()) return false;
    // check if the purchase order awb_number is filled
    if (purchaseOrder.awb_number === '' || purchaseOrder.awb_number === null) {
      let newErrors = {};
      if (purchaseOrder.awb_number === '' || purchaseOrder.awb_number === null) {
        newErrors['awb_number'] = 'required field';
      }
      setErrors(newErrors);
      return;
    }

    setIsSaving(true);
    ajaxSaveAwbPurchaseOrder({id: id, awb_number: purchaseOrder.awb_number})
      .then((res) => {
        if (!res.error) {
          noty('Save successfully', 'success');
          setPurchaseOrder({...res.data});
          setDefaultPurchaseOrder({...res.data});
        }
      })
      .catch((error) => {
        console.error('Error saving AWB number:', error);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const handlePay = (id) => () => {
    if (!purchaseOrder.proof_payment_pdf) {
      setErrors(prev => ({ ...prev, proof_payment_pdf: 'Proof of payment PDF is required' }));
      return;
    }

    setIsSaving(true);
    ajaxPayPurchaseOrder({
      PurchaseOrderId: id,
      proofPaymentPdf: purchaseOrder.proof_payment_pdf
    })
      .then((res) => {
        if (!res.error) {
          setPurchaseOrder({...res.data});
          setDefaultPurchaseOrder({...res.data});
          // Reset file input and states
          setNewFileSelected(false);
          setPurchaseOrder(prev => ({ ...prev, proof_payment_pdf: null }));
          // Reset the file input element
          const fileInput = document.querySelector('input[name="proof_payment_pdf"]');
          if (fileInput) {
            fileInput.value = '';
          }
          // Force FileUploader to reset
          setFileUploaderKey(prev => prev + 1);
          noty('Proof of payment has been uploaded successfully', 'success');
        }
      })
      .catch((error) => {
        console.error('Error uploading proof of payment:', error);
        noty(error.message || 'Error uploading proof of payment', 'error');
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const handleUploadSupplierQuote = (id) => () => {
    if (!purchaseOrder.supplier_quote_pdf) {
      setErrors(prev => ({ ...prev, supplier_quote_pdf: 'Supplier quote PDF is required' }));
      return;
    }

    setIsSaving(true);
    ajaxUploadSupplierQuote({
      PurchaseOrderId: id,
      supplierQuotePdf: purchaseOrder.supplier_quote_pdf
    })
      .then((res) => {
        if (!res.error) {
          setPurchaseOrder({...res.data});
          setDefaultPurchaseOrder({...res.data});
          // Reset file input and states
          setNewSupplierQuoteSelected(false);
          setPurchaseOrder(prev => ({ ...prev, supplier_quote_pdf: null }));
          // Reset the file input element
          const fileInput = document.querySelector('input[name="supplier_quote_pdf"]');
          if (fileInput) {
            fileInput.value = '';
          }
          // Force FileUploader to reset
          setFileUploaderKey(prev => prev + 1);
          noty('Supplier quote has been uploaded successfully', 'success');
        }
      })
      .catch((error) => {
        console.error('Error uploading supplier quote:', error);
        noty(error.message || 'Error uploading supplier quote', 'error');
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const handleSave = (revise, duplicate, showNoty = true) => () => {
    if (!validateFields()) return false;
    if(Object.keys(duplicateErrors).filter(k => !!duplicateErrors[k]).length > 0) {
      return false;
    }

    setSubmitOnce(true);
    setIsSaving(true);
    const params = {
      ...purchaseOrder,
      ...!!revise ? {revise: true} : {},
      ...!!duplicate ? {duplicate: true} : {},
      parts: purchaseOrder.parts.map(p => {
        let newPart = {...p};
        delete newPart.id;
        return newPart;
      })
    };

    ajaxSavePurchaseOrder(params)
      .then((res) => {
        if(showNoty){
          if (!res.error) {
            if ( duplicate ){
              noty('Duplicate successfully', 'success');
            } else if (revise) {
              noty('Revise successfully', 'success');
            } else {
              noty('Save successfully', 'success');
            }
          }
        }
        setPurchaseOrder({...res.data});
        setDefaultPurchaseOrder({...res.data});
        setIsSaving(false);

        if ( props.add ) {
          navigate('/purchaseorders/edit/' + res.data.id);
        }
      })
      .catch((e) => {
        if (e.cause) {
          let errorResult = {};
          for (let k in e.cause) {
            if (allFields.filter(f => f.key === k).length > 0) {
              errorResult[k] = e.cause[k];
            }
          }
          setDuplicateErrors(errorResult);
        }
        setIsSaving(false);
        console.log(e.message);
      });
  };

  const handleFieldChange = (event, val) => {
    let value = val !== undefined ? val : event.target.value,
        key = typeof event === 'string' ? event : event.target.name,
        field = allFields.find(f => f.key === key);

    if (key === 'supplier' && value !== null && purchaseOrder && purchaseOrder.supplier !== value.value) {
      setSupplierChanged(true);
    }

    if (key === 'po_number') {
      setDuplicateErrors({});
    }

    if (field && (field.type === 'autocomplete' || field.type === 'autocomplete_with_edit')) {
      setPurchaseOrder({ ...purchaseOrder, [key]: value ? value.value : null });
    } else if (field && field.type === 'text' && field.convertToDB) {
      setPurchaseOrder({ ...purchaseOrder, [key]: field.convertToDB(value), [key + '_UI']: value });
    } else {
      setPurchaseOrder({ ...purchaseOrder, [key]: value });
    }
  };

  const getFieldValue = (key) => purchaseOrder && purchaseOrder[key] !== undefined && purchaseOrder[key] !== null ? purchaseOrder[key] : '';

  const getFieldErrorText = (key) => errors && errors[key] ? errors[key] : (duplicateErrors && duplicateErrors[key] ? duplicateErrors[key] : '');

  const checkFieldError = (key) => (errors && errors[key]) || (duplicateErrors && duplicateErrors[key]);

  const buttonStyle = {
    height: '40px',
    width: '150px',
    fontSize: '12px'
  };

  const buttonSaveStyle = {
    height: '40px',
    width: '180px',
    fontSize: '12px'
  };

  const buttonReceivedStyle = {
    height: '40px',
    width: '200px',
    fontSize: '12px',
    backgroundColor: 'info'
  };

  const filteredApprovalUsers = useMemo(() => {
    if (!searchApprovalUser) return approvalUsers;
    const searchLower = searchApprovalUser.toLowerCase();
    return approvalUsers.filter(user => 
      `${user.first_name} ${user.last_name}`.toLowerCase().includes(searchLower) ||
      (user.position || user.user_role || '').toLowerCase().includes(searchLower) ||
      selectedApprovalUsers.includes(user.id)
    );
  }, [approvalUsers, searchApprovalUser, selectedApprovalUsers]);

  const handleUploadFile = (e) => {
    let key = e.target.name;
    let value = e.target.files[0];
    if (value) {
      setPurchaseOrder(prev => ({ ...prev, [key]: value }));
      if (key === 'proof_payment_pdf') {
        setNewFileSelected(true);
      } else if (key === 'supplier_quote_pdf') {
        setNewSupplierQuoteSelected(true);
      }
      // Clear any existing error for this field
      setErrors(prev => ({ ...prev, [key]: '' }));
    }
  };

  const handleCancel = (id) => () => {
    setShowCancelDialog(true);
  };

  const handleConfirmCancel = () => {
    if (!cancelReason.trim()) {
      setCancelError('Reason is required');
      return;
    }

    setIsSaving(true);
    // Send data in the format the backend expects
    const cancelData = {
      PurchaseOrderId: purchaseOrder.id,  // Changed from PurchaseOrderId to id to match backend expectation
      reason: cancelReason.trim()
    };

    ajaxCancelPurchaseOrder(cancelData)
      .then((res) => {
        if (!res.error) {
          setPurchaseOrder({...res.data});
          setDefaultPurchaseOrder({...res.data});
          setShowCancelDialog(false);
          setCancelReason('');
          setCancelError('');
          noty('Purchase order has been cancelled successfully', 'success');
        } else {
          setCancelError(res.error);
        }
      })
      .catch((error) => {
        console.error('Error cancelling purchase order:', error);
        setCancelError(error.message || 'Error cancelling purchase order');
        noty(error.message || 'Error cancelling purchase order', 'error');
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Page title="Add / Edit Purchase Order">
      <StyledCard>
        <StyledCardFormContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            { !props.add && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{ 
                  fontSize: '1.25rem',
                  fontWeight: 500,
                  color: 'text.primary',
                  letterSpacing: '0.5px'
                }}>
                  {purchaseOrder.po_number}
                </Box>
                <Chip
                  size="small"
                  label={
                    purchaseOrder.status === 'draft' ? 'Draft' :
                    purchaseOrder.status === 'waitingapproval' ? 'Waiting Approval' :
                    purchaseOrder.status === 'approved' ? 'Approved' :
                    purchaseOrder.status === 'rejected' ? 'Rejected' :
                    purchaseOrder.status === 'received' ? 'Received' :
                    purchaseOrder.status === 'cancelled' ? 'Cancelled' :
                    'Unknown'
                  }
                  color={
                    purchaseOrder.status === 'draft' ? 'default' :
                    purchaseOrder.status === 'waitingapproval' ? 'warning' :
                    purchaseOrder.status === 'approved' ? 'success' :
                    purchaseOrder.status === 'rejected' ? 'error' :
                    purchaseOrder.status === 'received' ? 'info' :
                    purchaseOrder.status === 'cancelled' ? 'error' :
                    'default'
                  }
                />
              </Box>
            )}
            {!props.add && (inMemoryUser.isAdmin() || inMemoryUser.isPurchase()) && (
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Link to={`/events/purchaseorder/${purchaseOrder.id}`}>
                  View Events
                </Link>
                <Link to={`/purchaseorders/history/${purchaseOrder.id}`}>
                  View History
                </Link>
              </Box>
            )}
          </Box>

          <form onSubmit={(e) => {
            e.preventDefault();
            handleSave(false, false)();
          }}>
            <Grid container spacing={3}>
              {Object.keys(duplicateErrors).length > 0 && (
                <Grid item xs={12}>
                  <Alert severity="error" onClose={() => setDuplicateErrors({})}>
                    {Object.values(duplicateErrors).join(', ')}
                  </Alert>
                </Grid>
              )}
              {allFields.map((entry) => 
                <React.Fragment key={entry['key']}>
                  { (entry['type'] === 'component') && 
                    <Grid item xs={12} {...entry['gridProps']}>
                      <entry.component {...entry.componentProps} beforeRedirect={handleSave(false, false)}/>
                    </Grid>
                  }
                  {
                    (entry['type'] === 'text') &&
                    <Grid item xs={12} {...entry['gridProps']}>
                      <TextField
                        label={entry['label']}
                        type={entry['type']}
                        name={entry['key']}
                        size="small"
                        value={entry['convertToUI'] ? entry['convertToUI'](getFieldValue(entry['key'])) : getFieldValue(entry['key'])}
                        onChange={handleFieldChange}
                        error={checkFieldError(entry['key'])}
                        helperText={getFieldErrorText(entry['key'])}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        disabled={!!entry.disabled}
                        autoFocus={!!entry.autoFocus}
                        {...entry.multiline ? { multiline: true, rows: entry.lineNum ? entry.lineNum : 4 } : {}}
                      />
                    </Grid>
                  }
                  {
                    entry['type'] === 'select' &&
                    <Grid item xs={12} {...entry['gridProps']}>
                      <FormControl fullWidth disabled={!!entry.disabled} error={checkFieldError(entry['key'])}>
                        <InputLabel id={`select-helper-label-${entry['key']}`}>{entry['label']}</InputLabel>
                        <Select
                          labelId={`select-helper-label-${entry['key']}`}
                          label={entry['label']}
                          type={entry['type']}
                          name={entry['key']}
                          size="small"
                          value={getFieldValue(entry['key'])}
                          onChange={(e) => handleFieldChange(e)}
                          sx={{ width: '100%' }}
                          endAdornment={
                            entry.hasEdit && inMemoryUser.isAdmin() ? (
                              <InputAdornment position="end">
                                <IconButton
                                  size="small"
                                  onClick={entry.onEdit}
                                  sx={{ mr: 1 }}
                                >
                                  <EditIcon />
                                </IconButton>
                              </InputAdornment>
                            ) : null
                          }
                        >
                          { (entry.dataset || []).map( c =>
                            <MenuItem value={c.value}>{c.label}</MenuItem>
                          )}
                        </Select>
                        <FormHelperText>{getFieldErrorText(entry['key'])}</FormHelperText>
                      </FormControl>
                    </Grid>
                  }
                  {
                    entry['type'] === 'autocomplete' &&
                    <Grid item xs={12} {...entry['gridProps']}>
                      <FormControl fullWidth disabled={!!entry.disabled} error={checkFieldError(entry['key'])}>
                        <Autocomplete
                          sx={{ width: '100%' }}
                          size="small" 
                          value={(entry.dataset || []).find(o=>o.value === getFieldValue(entry['key'])) || null}
                          options={(entry.dataset || [])}
                          isOptionEqualToValue={(option, value) => value && option.value === value.value}
                          getOptionLabel={(option) => option.label !== option.value ? `${option.label} [${option.value}]` : option.label}
                          onChange={(_,v)=>handleFieldChange(entry['key'], v)}
                          disabled={!!entry.disabled}
                          renderInput={(params) => <TextField {...params} label={entry['label']} disabled={!!entry.disabled}/>}
                        />
                        <FormHelperText>{getFieldErrorText(entry['key'])}</FormHelperText>
                      </FormControl>
                    </Grid>
                  }
                  {
                    entry['type'] === 'autocomplete_with_edit' &&
                    <Grid item xs={12} {...entry['gridProps']}>
                      <FormControl fullWidth disabled={!!entry.disabled} error={checkFieldError(entry['key'])} sx={entry.sx}>
                        <Autocomplete
                          disableClearable
                          sx={{ width: '100%' }}
                          size="small"
                          value={(entry.dataset || []).find(o=>o.value === getFieldValue(entry['key'])) || null}
                          options={(entry.dataset || [])}
                          isOptionEqualToValue={(option, value) => value && option.value === value.value}
                          getOptionLabel={(option) => option.label}
                          onChange={(_,v)=>handleFieldChange(entry['key'], v)}
                          disabled={!!entry.disabled}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={entry['label']}
                              disabled={!!entry.disabled}
                              error={checkFieldError(entry['key'])}
                              helperText={getFieldErrorText(entry['key'])}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {params.InputProps.endAdornment}
                                    {entry.hasEdit && inMemoryUser.isAdmin() && (
                                      <InputAdornment position="end">
                                        <IconButton
                                          size="small"
                                          onClick={entry.onEdit}
                                        >
                                          <EditIcon />
                                        </IconButton>
                                      </InputAdornment>
                                    )}
                                  </>
                                )
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                  }
                  {
                    entry['type'] === 'list' &&
                    <Grid item xs={12} {...entry['gridProps']}>
                      <FormControl fullWidth disabled={!!entry.disabled} error={checkFieldError(entry['key'])}>
                        <InputLabel id={`select-helper-label-${entry['key']}`}>{entry['label']}</InputLabel>
                        <Select
                          labelId={`select-helper-label-${entry['key']}`}
                          label={entry['label']}
                          type={entry['type']}
                          name={entry['key']}
                          size="small"
                          value={getFieldValue(entry['key'])}
                          onChange={(e) => handleFieldChange(e)}
                          sx={{ width: '100%' }}
                        >
                          { (entry.dataset || []).map( c =>
                            <MenuItem value={c.value}>{c.label}</MenuItem>
                          )}
                        </Select>
                        <FormHelperText>{getFieldErrorText(entry['key'])}</FormHelperText>
                      </FormControl>
                    </Grid>
                  }
                  {
                    entry['type'] === 'date' &&
                    <Grid item xs={12} {...entry['gridProps']}>
                      <Box sx={entry.sx}>
                        <UtcDatePicker
                          label={entry['label']}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              size: "small",
                              error: checkFieldError(entry['key']),
                              helperText: getFieldErrorText(entry['key'])
                            },
                          }}
                          value={getFieldValue(entry['key']) ? moment(toDate(getFieldValue(entry['key']))).unix() : null}
                          onChange={(value) => handleFieldChange(entry['key'], value)}
                          disabled={!!entry.disabled}
                        />
                      </Box>
                    </Grid>
                  }
                  {
                    entry['type'] === 'checkbox' &&
                    <Grid item xs={12} {...entry['gridProps']}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={getFieldValue(entry['key']) === 1}
                            onChange={(e) => handleFieldChange(entry['key'], e.target.checked ? 1 : 0)}
                            disabled={!!entry.disabled}
                          />
                        }
                        label={entry['label']}
                        sx={entry.sx}
                      />
                    </Grid>
                  }
                  {
                    entry['type'] === 'file' &&
                    <Grid item xs={12} {...entry['gridProps']}>
                      <FormControl fullWidth disabled={!!entry.disabled} error={checkFieldError(entry['key'])}>
                        <FileUploader
                          key={fileUploaderKey}
                          error={checkFieldError(entry['key'])}
                          accept=".pdf"
                          name={entry['key']}
                          label={entry['label']}
                          icon={<AttachFileIcon />}
                          handleChange={handleUploadFile}
                          disabled={!!entry.disabled}
                        />
                        <FormHelperText>{getFieldErrorText(entry['key'])}</FormHelperText>
                      </FormControl>
                    </Grid>
                  }
                  {
                    entry['divider'] && 
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  }
                </React.Fragment>
              )}
              {
                paramPurchaseOrderId !== -1 && defaultPurchaseOrder.status === 'waitingapproval' &&
                (inMemoryUser.isAdmin() || inMemoryUser.isPoApproval()) &&
                <>
                <Grid item xs={12} sm={9}>
                  <ConfirmationButton
                    buttonProps={{
                      disabled: isSaving,
                      variant: 'contained',
                      size: 'medium',
                      style: buttonStyle,
                      sx: { backgroundColor: 'blue', mr: '20px' },
                    }}
                    handleDialogClickYes={handleApprove(purchaseOrder.id)}
                    buttonText={ "Approve" }
                    dialogText={ "Are you sure you want to approve the purchase order?" }
                    dialogYesText="Confirm"
                    dialogNoText="Cancel"
                  />
                  <ConfirmationButton
                    buttonProps={{
                      disabled: isSaving,
                      variant: 'contained',
                      size: 'medium',
                      style: buttonStyle,
                      sx: { backgroundColor: 'red' },
                    }}
                    handleDialogClickYes={handleReject(purchaseOrder.id)}
                    buttonText={ "Reject" }
                    dialogText={ "Are you sure you want to reject the purchase order?" }
                    dialogYesText="Confirm"
                    dialogNoText="Cancel"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                </>
              }
              {
                paramPurchaseOrderId !== -1 && defaultPurchaseOrder.status === 'draft' &&
                !isNotAdminOrPurchase &&
                <>
                <Grid item xs={12} sm={9}>
                  <Button
                    variant="contained"
                    size="medium"
                    style={buttonStyle}
                    sx={{
                      backgroundColor: 'blue',
                      mr: '20px'
                    }}
                    onClick={handleRequestApproval(purchaseOrder.id)}
                    disabled={isSaving}
                  >
                    Request Approval
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                </>
              }
                {(paramPurchaseOrderId !== -1 && (defaultPurchaseOrder.status === 'approved' || defaultPurchaseOrder.status === 'received') && !isNotAdminOrPurchase) && (
                  <>
                  <Grid item xs={12}>
                    <Box>
                      <FormControl error={checkFieldError('proof_payment_pdf')}>
                        <FileUploader
                          key={fileUploaderKey}
                          error={checkFieldError('proof_payment_pdf')}
                          accept=".pdf"
                          name="proof_payment_pdf"
                          label="Proof of Payment"
                          icon={<AttachFileIcon />}
                          handleChange={handleUploadFile}
                          disabled={(!inMemoryUser.isAdmin() && !inMemoryUser.isPurchase()) || (defaultPurchaseOrder.status !== 'approved' && defaultPurchaseOrder.status !== 'received')}
                        />
                        <FormHelperText>{getFieldErrorText('proof_payment_pdf')}</FormHelperText>
                      </FormControl>
                      <ConfirmationButton
                        buttonProps={{
                          disabled: isSaving || !newFileSelected,
                          variant: 'contained',
                          size: 'small',
                          sx: { backgroundColor: 'info' }
                        }}
                        handleDialogClickYes={handlePay(purchaseOrder.id)}
                        buttonText="Upload"
                        dialogText="Are you sure you want to upload this proof of payment and mark the purchase order as paid?"
                        dialogYesText="Confirm"
                        dialogNoText="Cancel"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                </>
              )}
              {
                paramPurchaseOrderId !== -1 && defaultPurchaseOrder.status === 'approved' &&
                inMemoryUser.isAdmin() &&
                <>
                <Grid item xs={12} sm={9}>
                  <ConfirmationButton
                    buttonProps={{
                      disabled: isSaving,
                      variant: 'contained',
                      size: 'medium',
                      style: buttonReceivedStyle,
                      sx: { backgroundColor: 'info' },
                    }}
                    handleDialogClickYes={handleReceive(purchaseOrder.id)}
                    buttonText={"Mark as Received" }
                    dialogText={"Are you sure you want to mark this purchase order as received?"}
                    dialogYesText="Confirm"
                    dialogNoText="Cancel"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                </>
              }
              {(paramPurchaseOrderId !== -1 && (defaultPurchaseOrder.status === 'draft' || defaultPurchaseOrder.status === 'waitingapproval') && !isNotAdminOrPurchase) && (
                <>
                  <Grid item xs={12}>
                    <Box>
                      <FormControl error={checkFieldError('supplier_quote_pdf')}>
                        <FileUploader
                          key={fileUploaderKey}
                          error={checkFieldError('supplier_quote_pdf')}
                          accept=".pdf"
                          name="supplier_quote_pdf"
                          label="Supplier Quote"
                          icon={<AttachFileIcon />}
                          handleChange={handleUploadFile}
                          disabled={(!inMemoryUser.isAdmin() && !inMemoryUser.isPurchase()) || (defaultPurchaseOrder.status !== 'draft' && defaultPurchaseOrder.status !== 'waitingapproval')}
                        />
                        <FormHelperText>{getFieldErrorText('supplier_quote_pdf')}</FormHelperText>
                      </FormControl>
                      <ConfirmationButton
                        buttonProps={{
                          disabled: isSaving || !newSupplierQuoteSelected,
                          variant: 'contained',
                          size: 'small',
                          sx: { backgroundColor: 'info' }
                        }}
                        handleDialogClickYes={handleUploadSupplierQuote(purchaseOrder.id)}
                        buttonText="Upload"
                        dialogText="Are you sure you want to upload this supplier quote?"
                        dialogYesText="Confirm"
                        dialogNoText="Cancel"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                </>
              )}
              <Grid item xs={12} sm={12}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box sx={{ display: 'flex' }}>
                    {
                      (paramPurchaseOrderId === -1 || (defaultPurchaseOrder.status === 'draft' && !isNotAdminOrPurchase)) && !isCancelled &&
                      <Button disabled={isSaving} variant="contained" size="normal" style={buttonSaveStyle} sx={{ backgroundColor: 'green', mr: '20px' }} onClick={handleSave(false, false)}>
                        Save Purchase Order
                      </Button>
                    }
                    {
                      (paramPurchaseOrderId !== -1 && (defaultPurchaseOrder.status === 'approved' || defaultPurchaseOrder.status === 'received') && (inMemoryUser.isShipping() || inMemoryUser.isPurchase())) && !isCancelled &&
                      <Button disabled={isSaving} variant="contained" size="normal" style={buttonSaveStyle} sx={{ backgroundColor: 'green', mr: '20px' }} onClick={handleSaveShippingCost(purchaseOrder.id)}>
                        Save Shipping Cost
                      </Button>
                    }
                    {
                      (paramPurchaseOrderId !== -1 && (defaultPurchaseOrder.status === 'approved' || defaultPurchaseOrder.status === 'received') && (inMemoryUser.isQa() || inMemoryUser.isPurchase())) && !isCancelled &&
                      <Button disabled={isSaving} variant="contained" size="normal" style={buttonSaveStyle} sx={{ backgroundColor: 'green', mr: '20px' }} onClick={handleSaveAWBNumber(purchaseOrder.id)}>
                        Save AWB Number
                      </Button>
                    }
                    {
                      paramPurchaseOrderId !== -1 && defaultPurchaseOrder.status !== 'draft' && !isNotAdminOrPurchase && !isCancelled &&
                      <ConfirmationButton
                        buttonProps={{
                          disabled: isSaving,
                          variant: 'contained',
                          size: 'medium',
                          sx: { backgroundColor: 'green', mr: '20px' },
                          style: buttonStyle
                        }}
                        handleDialogClickYes={handleSave(true, false)}
                        buttonText={ "Revise" }
                        dialogText={ "Are you sure you want to revise the purchase order?" }
                        dialogYesText="Confirm"
                        dialogNoText="Cancel"
                      />
                    }
                    {
                      (paramPurchaseOrderId !== -1 && !isNotAdminOrPurchase && !isCancelled) &&
                      <ConfirmationButton
                        buttonProps={{
                          disabled: isSaving,
                          variant: 'contained',
                          size: 'medium',
                          sx: { backgroundColor: 'blue', mr: '20px' },
                          style: buttonStyle
                        }}
                        handleDialogClickYes={handleSave(false, true)}
                        buttonText={ "Duplicate" }
                        dialogText={ "Are you sure you want to duplicate the purchase order?" }
                        dialogYesText="Confirm"
                        dialogNoText="Cancel"
                      />
                    }
                    <Button variant="outlined" size="normal" style={buttonStyle} onClick={() => navigate(backUrl)}>
                      Back
                    </Button>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    {paramPurchaseOrderId !== -1 && (defaultPurchaseOrder.status === 'approved' || defaultPurchaseOrder.status === 'received') && (
                      <LoadingButton
                        variant="outlined"
                        size="normal"
                        style={buttonStyle}
                        startIcon={<PictureAsPdfIcon />}
                        onClickPromise={() => downloadFile({
                          params: { id: purchaseOrder.id, fileType: 'purchase_order/po_pdf'},
                          fileName: purchaseOrder.po_number,
                          fileExt: 'pdf'
                        })}
                      >
                        Download
                      </LoadingButton>
                    )}
                    {paramPurchaseOrderId !== -1 &&
                     ((defaultPurchaseOrder.status === 'approved' || defaultPurchaseOrder.status === 'received') ?
                       inMemoryUser.isAdmin() :
                       !isNotAdminOrPurchase) &&
                     !isCancelled && (
                      <Button
                        variant="contained"
                        size="normal"
                        style={buttonStyle}
                        color="error"
                        onClick={handleCancel(purchaseOrder.id)}
                        disabled={isSaving}
                      >
                        Cancel PO
                      </Button>
                    )}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </form>
        </StyledCardFormContent>
      </StyledCard>

      {/* Approval User Selection Dialog */}
      <Dialog
        open={showApprovalDialog}
        onClose={() => setShowApprovalDialog(false)}
        aria-labelledby="approval-dialog-title"
        aria-describedby="approval-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="approval-dialog-title">
          Request Approval
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="approval-dialog-description" sx={{ mb: 2 }}>
          Please select the users to notify via email for approval.
          </DialogContentText>
          <TextField
            fullWidth
            size="small"
            placeholder="Search users..."
            value={searchApprovalUser}
            onChange={(e) => setSearchApprovalUser(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{ mb: 2 }}
            disabled={isSaving}
          />
          <List sx={{ 
            width: '100%', 
            maxHeight: 300, 
            overflow: 'auto',
            border: '1px solid #e0e0e0',
            bgcolor: 'background.paper',
            '& .MuiListItemButton-root': {
              py: 0.5,
            }
          }}>
            {filteredApprovalUsers.sort((a, b) => `${a.first_name} ${a.last_name}`.localeCompare(`${b.first_name} ${b.last_name}`)).map((user) => (
              <ListItem key={user.id} disablePadding>
                <ListItemButton
                  role={undefined}
                  onClick={() => {
                    const newSelected = selectedApprovalUsers.includes(user.id)
                      ? selectedApprovalUsers.filter(id => id !== user.id)
                      : [...selectedApprovalUsers, user.id];
                    setSelectedApprovalUsers(newSelected);
                  }}
                  disabled={isSaving}
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={selectedApprovalUsers.includes(user.id)}
                      tabIndex={-1}
                      disableRipple
                      disabled={isSaving}
                    />
                  </ListItemIcon>
                  <ListItemText 
                    primary={`${user.first_name} ${user.last_name}`}
                    secondary={user.position || user.user_role}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowApprovalDialog(false);
              setSelectedApprovalUsers([]);
              setSearchApprovalUser('');
            }}
            disabled={isSaving}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleConfirmApprovalRequest} 
            variant="contained" 
            color="primary"
            disabled={selectedApprovalUsers.length === 0 || isSaving}
          >
            Send for Approval
          </Button>
        </DialogActions>
      </Dialog>

      <PoDepartmentDialog
        open={showDepartmentDialog}
        onClose={() => setShowDepartmentDialog(false)}
        onSave={handleDepartmentSave}
      />
      <PoTermDialog
        open={showTermDialog}
        onClose={() => setShowTermDialog(false)}
        onSave={handleTermSave}
      />
      <PoPriceQuoteDialog
        open={showPriceQuoteDialog}
        onClose={() => setShowPriceQuoteDialog(false)}
        onSave={handlePriceQuoteSave}
      />

      <Dialog
        open={showCancelDialog}
        onClose={() => {
          setShowCancelDialog(false);
          setCancelReason('');
          setCancelError('');
        }}
        aria-labelledby="cancel-dialog-title"
        aria-describedby="cancel-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="cancel-dialog-title">
          Cancel Purchase Order
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="cancel-dialog-description" sx={{ mb: 2 }}>
            Please provide a reason for cancelling this purchase order.
          </DialogContentText>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Reason for Cancellation"
            value={cancelReason}
            onChange={(e) => {
              setCancelReason(e.target.value);
              setCancelError('');
            }}
            error={!!cancelError}
            helperText={cancelError}
            sx={{ mb: 2 }}
            disabled={isSaving}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowCancelDialog(false);
              setCancelReason('');
              setCancelError('');
            }}
            disabled={isSaving}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmCancel}
            variant="contained"
            color="error"
            disabled={!cancelReason.trim() || isSaving}
          >
            Confirm Cancellation
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}